export default class Address {
  constructor ({ line1 = null, line2 = null, box = null, number = null, postal_code = null, city = null, country = null, state = null, latitude = null, longitude = null } = {}) {
    this.line1 = line1
    this.line2 = line2
    this.box = box
    this.number = number
    this.postal_code = postal_code
    this.city = city
    this.country = country
    this.state = state
    this.latitude = latitude
    this.longitude = longitude
  }

  get to_html () {
    return [[this.line1, this.number, this.box], this.line2, [this.postal_code, this.city], this.country].map(v => Array.isArray(v) ? v.filter(v => v).join(' ') : v).filter(v => v).join('<br/>')
  }
}